import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonTs } from 'src/app/shared/common/CommonTs';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { EtlService } from '../../vault-data-migration-etl/etl.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialogRef } from '@angular/material/dialog';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ErrorMessages } from 'src/app/shared/common/errormessages';

@Component({
    selector: 'app-delete-objcts-popup',
    templateUrl: './delete-objcts-popup.component.html',
    styleUrls: ['./delete-objcts-popup.component.scss'],
    standalone: false
})
export class DeleteObjctsPopupComponent implements OnInit {

  statevaluechange = { "fileName": "", "fileData": "" };
  imagephoto;
  imagephotoshow: any = false;
  backgroundColorScreen: any;
  backgroundColorButton: any;
  buttonColor = '';
  MappingFile;
  objectsList: any = [];
  /**
  * Modified by Ashwin M
  * 08/07/2024
  * code modified to add validation messages for object level deletion
  */
  validationMessages:any;

  FormValid = new UntypedFormGroup({
    imageName: new UntypedFormControl('', [Validators.required]),
    imageupload: new UntypedFormControl('', [Validators.required]),
    object: new UntypedFormControl('', [Validators.required])
  });

  constructor(private msg: ErrorMessages,private commonTs: CommonTs, private snackbar: MatSnackBar,
    private localStorageSettings: LocalStorageSettingsService, private validation: validationmethod,
    private service: EtlService, private spinner: NgxUiLoaderService,
    private dialogref: MatDialogRef<DeleteObjctsPopupComponent>, private reportService: ReportingServiceService) {
      /**
       * Modified by Ashwin M
       * 08/07/2024
       * code modified to add validation messages for object level deletion
       */
      this.validationMessages = this.msg.caseDeletionPopup;
  }

  ngOnInit(): void {
    this.spinner.start();
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.buttonColor = this.localStorageSettings.getSettings('ColorA');
    this.retrieveAllObjects();
  }

  imagePhotofunction($event, filecheck): void {
    //this.readThisimage($event.target, filecheck);
    this.readThisimageState($event.target, filecheck);
  }

  readThisimageState(inputValue: any, filecheck: any): void {
    let ischeckfile = false;
    var file: File = inputValue.files[0];
    var FileS: File = inputValue.files[0];
    console.log(file.type);
    if (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') {

      console.log(file.size);
      console.log(file.size / 1000);
      var size = file.size / 1000;
      var fileName = FileS.name;
      //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

      var photo: FileReader = new FileReader();
      photo.onloadend = e => {
        var img = photo.result;
        console.log(photo.result);
        var photobase64result = photo.result.toString().split(',', 2)[1];

        // this is to check the file is empty or not
        if (photobase64result == null) {
          console.log('photobase64result is null');
          this.statevaluechange.fileData = null;
            this.statevaluechange.fileName = null;
        } else {
          // if (reportType=== 'quantitative')
          // {
            this.imagephoto = photo.result.toString();
            this.imagephotoshow = true;
            this.statevaluechange.fileData = photobase64result;
            this.statevaluechange.fileName = fileName;
            console.log(this.statevaluechange);
            this.FormValid.controls.imageName.setValue(fileName);
          // }else{
          //   this.imagephoto = photo.result.toString();
          //   this.imagephotoshow = true;
          //   this.statevaluechange.fileData = photobase64result;
          //   this.statevaluechange.fileName = fileName;
          //   this.statevaluechange.fileData = null;
          //   this.statevaluechange.fileName = null;
          //   console.log(this.statevaluechange);
          //   this.FormValid.controls.imageName.setValue(fileName);
          // }
          // this.filetype= reportType;
        }
      };
      photo.readAsDataURL(file);
    } else {
      this.snackbar.open(file.name + ' is a invalid file type ', 'OK', {
        duration: 5000,
      });
    }

  }

  uploadFile() {
    console.log(this.statevaluechange.fileData)
    if (!this.FormValid.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.FormValid);

      this.validation.getvalidationmessage();

    } else {
      if (this.statevaluechange.fileData !== "") {
        if (this.MappingFile !== null || this.MappingFile !== "" || this.MappingFile !== undefined) {
          if (confirm("Are you sure you want to overwrite the existing file.")) {
            this.spinner.start()
            this.statevaluechange.fileName = "DM_Mappingfile.xlsx";
            let dnsName = this.localStorageSettings.getSettings("vaultDnsname");
            this.service.uploadMappingFile(this.statevaluechange, dnsName).subscribe(response => {
              console.log(response);
              // checking if response is true or not
              if (response.error == true) {
                this.spinner.stop();
                this.snackbar.open(response.statusMessage, "OK", {
                  duration: 5000,
                });

              } else {
                this.spinner.stop();
                console.log(response)
                this.snackbar.open(response.statusMessage, "OK", {
                  duration: 5000,
                });

              }
              this.cancel();
              this.spinner.stop();
            });
          } else {

            this.cancel();
          }
          this.FormValid.reset();
        }
      } else {
        this.snackbar.open("Please select the CSV file", "OK", {
          duration: 5000,
        });
      }

    }
  }

  cancel() {
    this.statevaluechange.fileData = "";
    this.statevaluechange.fileName = "";
    this.FormValid.reset();
    this.formvalidations();
    this.FormValid.clearValidators();
  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      imageName: new UntypedFormControl('', [Validators.required]),
      imageupload: new UntypedFormControl('', [Validators.required]),
      object: new UntypedFormControl('', [Validators.required])
    });
  }

  closeFunction() {
    this.dialogref.close();
  }

  initateDeletion(){
    if (this.statevaluechange.fileName == "" || this.statevaluechange.fileData == "" || this.FormValid.controls['object'].value == ''){
      this.snackbar.open('Please fill all madatory fields and try again', 'OK', {duration: 5000});
      this.FormValid.controls['imageName'].markAsTouched();
      this.FormValid.controls['object'].markAsTouched();
      this.FormValid.controls['imageName'].markAsDirty();
      this.FormValid.controls['object'].markAsDirty();
      return;
    }
    this.spinner.start();
    /**
     * Modified by Ashwin M
     * 15/10/2025
     * code modified to pass workspaceId to initiate deletion
     */
    let startMigrationRequest = {
      dnsId: this.localStorageSettings.getSettings("dnsName"),
      migrationType: 'Data Migration',
      fileName: this.statevaluechange.fileName,
      fileData: this.statevaluechange.fileData,
      dataExtractionType: 'Partial Data',
      sourcedns: this.localStorageSettings.getSettings("SelectedDnsName"),
      targetdns: this.localStorageSettings.getSettings("SelectedDnsName"),
      workspaceId: this.localStorageSettings.getSettings("WorkspaceId"),
      comment: "Migration to delete object Data from vault",
    }
    this.service.insertMigrationForDeletion(startMigrationRequest).subscribe((res:any)=>{
      if (!res.error){
        this.FormValid.reset();
        this.spinner.stopAll();
        this.dialogref.close();
      }
      this.snackbar.open(res.statusMessage +'  '+ res.data, 'OK', {duration: 5000});
      this.spinner.stopAll();
    });
  }

  retrieveAllObjects(){
    this.reportService.retrieveObjectsByDnsId(this.localStorageSettings.getSettings("dnsName")).subscribe(result=>{
      console.log(result);
      this.objectsList = result;
      this.spinner.stop();
    })
  }

}
